import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningTriangleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 98,
	height: 98,
	viewBox: "0 0 98 98",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42.0175 15.7616L7.43169 73.5C6.71861 74.7349 6.34131 76.135 6.33731 77.5609C6.33332 78.9869 6.70278 80.3891 7.40893 81.628C8.11509 82.8668 9.13332 83.8992 10.3623 84.6224C11.5913 85.3455 12.9883 85.7343 14.4142 85.75H83.5858C85.0118 85.7343 86.4087 85.3455 87.6377 84.6224C88.8667 83.8992 89.885 82.8668 90.5911 81.628C91.2973 80.3891 91.6667 78.9869 91.6627 77.5609C91.6587 76.135 91.2814 74.7349 90.5684 73.5L55.9825 15.7616C55.2546 14.5616 54.2296 13.5694 53.0066 12.8808C51.7835 12.1922 50.4036 11.8304 49 11.8304C47.5964 11.8304 46.2165 12.1922 44.9935 12.8808C43.7704 13.5694 42.7455 14.5616 42.0175 15.7616V15.7616Z",
			stroke: "#FAAB00",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49 36.75V53.0833",
			stroke: "#FAAB00",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49 69.4166H49.0408",
			stroke: "#FAAB00",
			strokeWidth: 5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWarningTriangleIcon;
